import { create } from 'zustand';

const useModalStore = create((set) => ({
  confirmModal: null,
  alertModal: null,

  showConfirmModal: (config) => set({ confirmModal: config }),
  closeConfirmModal: () => set({ confirmModal: null }),

  showAlertModal: (config) => set({ alertModal: config }),
  closeAlertModal: () => set({ alertModal: null }),

  showConfirmation: (config) => {
    return new Promise((resolve) => {
      set({
        confirmModal: {
          ...config,
          onConfirm: () => {
            set({ confirmModal: null });
            resolve(true);
          },
          onCancel: () => {
            set({ confirmModal: null });
            resolve(false);
          }
        }
      });
    });
  }
}));

export default useModalStore;
